import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import TaxiAdminDashboard from './AppAdmin';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <TaxiAdminDashboard />
  </React.StrictMode>
);

reportWebVitals();
